import React, { useState } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import icon5 from "../../../theme/assets/svg/b_cabinet_profile_icon5.svg";
import icon6 from "../../../theme/assets/svg/b_cabinet_profile_icon6.svg";

import settingsIcon from "../../../theme/assets/svg/b_cabinet_profile_2fa_settings_icon.svg";

import {
    setCabinetProfileChangePasswordModalStatus,
    setCabinetProfileTwoFactorModalStatus,
    set2faSettings,
    getProfileMainData, setCabinetProfileDisableTwoFactorModalStatus
} from "../../../store/cabinet/action";
import { toast } from "react-toastify";

import CabinetProfileTwoFactorSettingsModal from "../cabinetProfileTwoFactorSettingsModal";

const formatDate = (date) => {
    if (!date) return "—";

    const dateValue = new Date(date);

    if (Number.isNaN(dateValue.getTime())) return "—";

    return new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
    }).format(dateValue);
};

const CabinetProfileSecurity = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const profileMainData = useSelector(store => store.cabinet.profileMainData);
    const profile2faSettingsStatusStarted = useSelector(store => store.cabinet.profile2faSettingsStatusStarted);
    const profile2faSettingsStatusErr = useSelector(store => store.cabinet.profile2faSettingsStatusErr);

    const [isTwoFactorSettingsOpen, setIsTwoFactorSettingsOpen] = useState(false);

    const passwordChangedAt = profileMainData?.password_changed_at || null;
    const twoFactorData = profileMainData?.two_factor || {};

    const isTwoFactorEnabled = twoFactorData?.enabled || false;

    const changePasswordHandler = () => {
        dispatch(setCabinetProfileChangePasswordModalStatus(true));
    };

    const twoFactorHandler = () => {
        if (isTwoFactorEnabled) {
            setIsTwoFactorSettingsOpen(true);
            return;
        }

        dispatch(setCabinetProfileTwoFactorModalStatus(true));
    };

    const twoFactorDisableHandler = () => {
        dispatch(setCabinetProfileDisableTwoFactorModalStatus(true));
    };

    const twoFactorSettingsCloseHandler = () => {
        setIsTwoFactorSettingsOpen(false);
    };

    const twoFactorSettingsSaveHandler = (payload) => {
        const successHandler = () => {
            toast(t("Настройки 2FA успешно обновлены"));
            twoFactorSettingsCloseHandler();

            dispatch(getProfileMainData());
        };

        dispatch(set2faSettings(payload, successHandler));
    };

    return (
        <>
            <div className={Styles.container}>
                <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                    <div className={Styles.title}>
                        {t("Безопасность")}
                    </div>

                    <div className={Styles.securityList}>
                        <div className={Styles.securityItem}>
                            <div className={Styles.securityIcon}>
                                <img src={icon5} alt={t("Пароль")} />
                            </div>

                            <div className={Styles.securityText}>
                                <div className={Styles.securityName}>
                                    {t("Пароль")}
                                </div>

                                <div className={Styles.securityNote}>
                                    {t("Последнее изменение")}: {formatDate(passwordChangedAt)}
                                </div>
                            </div>

                            <button
                                type="button"
                                className={Styles.securityBtn}
                                onClick={changePasswordHandler}
                            >
                                {t("Изменить пароль")}
                            </button>
                        </div>

                        <div className={Styles.securityDivider} />

                        <div className={Styles.securityItem}>
                            <div className={Styles.securityIcon}>
                                <img src={icon6} alt={t("Двухфакторная аутентификация (2FA)")} />
                            </div>

                            <div className={Styles.securityText}>
                                <div className={Styles.securityName}>
                                    {t("Двухфакторная аутентификация (2FA)")}
                                </div>

                                <div className={Styles.securityNote}>
                                    {t("Добавьте дополнительный уровень защиты аккаунта")}
                                </div>
                            </div>

                            {isTwoFactorEnabled ? (
                                <div className={Styles.securityActions}>
                                    <div className={Styles.activeBadge}>
                                        {t("Активно")}
                                    </div>

                                    <button
                                        type="button"
                                        className={Styles.settingsBtn}
                                        onClick={twoFactorHandler}
                                        aria-label={t("Настроить 2FA")}
                                    >
                                        <img src={settingsIcon} alt={t("Настроить 2FA")} />
                                    </button>

                                    <button
                                        type="button"
                                        className={`${Styles.settingsBtn} ${Styles.disableBtn}`}
                                        onClick={twoFactorDisableHandler}
                                        aria-label={t("Отключить 2FA")}
                                    >
                                        <span className={Styles.disableIcon}>
                                            <span />
                                            <span />
                                        </span>
                                    </button>
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className={Styles.securityBtn}
                                    onClick={twoFactorHandler}
                                >
                                    {t("Подключить")}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <CabinetProfileTwoFactorSettingsModal
                open={isTwoFactorSettingsOpen}
                onClose={twoFactorSettingsCloseHandler}
                onSave={twoFactorSettingsSaveHandler}
                twoFactorData={twoFactorData}
                isLoading={profile2faSettingsStatusStarted}
                formErr={profile2faSettingsStatusErr}
            />
        </>
    );
};

export default CabinetProfileSecurity;